import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

interface WizardStepProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  onNext?: () => void;
  onBack?: () => void;
  nextLabel?: string;
  backLabel?: string;
  nextDisabled?: boolean;
  hideNext?: boolean;
  hideBack?: boolean;
}

const WizardStep: React.FC<WizardStepProps> = ({
  title,
  description,
  children,
  onNext,
  onBack,
  nextLabel,
  backLabel,
  nextDisabled = false,
  hideNext = false,
  hideBack = false,
}) => {
  const { t } = useTranslation('wizard');
  const resolvedNextLabel = nextLabel ?? t('common.continue');
  const resolvedBackLabel = backLabel ?? t('common.back');
  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-xl font-bold">{title}</h2>
        {description && (
          <p className="text-sm text-muted-foreground mt-1">{description}</p>
        )}
      </div>

      <div>
        {children}
      </div>

      {(!hideNext || !hideBack) && (
        <div className="flex items-center justify-between pt-3">
          {!hideBack ? (
            <Button
              variant="outline"
              size="sm"
              onClick={onBack}
              disabled={!onBack}
            >
              {resolvedBackLabel}
            </Button>
          ) : (
            <div />
          )}

          {!hideNext && (
            <Button
              size="sm"
              onClick={onNext}
              disabled={nextDisabled || !onNext}
            >
              {resolvedNextLabel}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default WizardStep;
